import { render } from "./GeneralInfoScenarioTab.vue?vue&type=template&id=10bcd22e&scoped=true"
import script from "./GeneralInfoScenarioTab.vue?vue&type=script&lang=js"
export * from "./GeneralInfoScenarioTab.vue?vue&type=script&lang=js"

import "./GeneralInfoScenarioTab.vue?vue&type=style&index=0&id=10bcd22e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bcd22e"]])

export default __exports__